import cn from 'classnames'

import { SecurityProps } from './Security.types'

export const Security = (props: SecurityProps) => {
    const { className } = props

    const items = [
        {
            title: 'Security',
            description: 'Your data is encrypted at rest and in transit using industry-standard protocols. We implement strict access controls and continuous monitoring.',
            icon: (
                <svg className='w-8 h-8 text-deep-purple-accent-400 sm:w-12 sm:h-12' stroke='currentColor' viewBox='0 0 24 24' fill='none'>
                    <path strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'/>
                </svg>
            ),
        },
        {
            title: 'Reliability',
            description: 'Nexly platform is designed for uninterrupted performance with robust infrastructure ensuring high availability and automatic backups.',
            icon: (
                <svg className='w-8 h-8 text-deep-purple-accent-400 sm:w-12 sm:h-12' stroke='currentColor' viewBox='0 0 24 24' fill='none'>
                    <path strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' d='M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'/>
                </svg>
            ),
        },
        {
            title: 'Confidentiality',
            description: 'We do not share or store your data beyond what is necessary for processing. Your files remain private and only authorized users can access them.',
            icon: (
                <svg className='w-8 h-8 text-deep-purple-accent-400 sm:w-12 sm:h-12' stroke='currentColor' viewBox='0 0 24 24' fill='none'>
                    <path strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' d='M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z'/>
                </svg>
            ),
        },
    ]

    return (
        <section className={cn('bg-white', className)}>
            <div className='px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20'>
                <div className='max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12'>
                    <h2 className='max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto'>
                        Your Data, Secure and Protected
                    </h2>
                    <p className='text-base text-gray-700 md:text-lg'>
                        We understand the sensitivity of financial statements. That's why our platform is built with security, reliability, and confidentiality at its core.
                    </p>
                </div>
                <div className='grid gap-8 row-gap-8 lg:grid-cols-3'>
                    {items.map((item) => (
                        <div key={item.title} className='sm:text-center'>
                            <div className='flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-50 mx-auto sm:w-24 sm:h-24'>
                                {item.icon}
                            </div>
                            <h6 className='mb-2 font-semibold leading-5'>{item.title}</h6>
                            <p className='max-w-md mb-3 text-sm text-gray-900 sm:mx-auto'>
                                {item.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
